import { useRouterState } from '@tanstack/react-router';
import { AdministrativeFrame, Missing } from './common';
import { AdministrativeOverview, AdministrativeCalendar } from './overview';
import { AdministrativeSections, AdministrativeSheetForm } from './sections';
import {
  AdministrativeResources,
  AdministrativeResourceDetail,
  AdministrativeResourceForm,
  AdministrativeRenewal,
  AdministrativeResourceLink,
  AdministrativePayments,
} from './resources';
import { AdministrativeProviders } from './providers';
import { AdministrativeAccess } from './access';
import { AdministrativeRegistry, AdministrativeAudit } from './registry';
import {
  AdministrativeSettings,
  AdministrativeTelegram,
  AdministrativeImport,
  AdministrativeJob,
} from './integrations';

export function AdministrativePage() {
  const location = useRouterState({ select: (state) => state.location });
  const [, , section, id, operation] = location.pathname.split('/');
  const search = location.search as Record<string, string>;
  let content;
  if (!section) content = <AdministrativeOverview />;
  else if (section === 'sections')
    content = <AdministrativeSections id={id} operation={operation} />;
  else if (section === 'sheets')
    content =
      id === 'new' || operation === 'edit' ? (
        <AdministrativeSheetForm id={id!} sectionId={search.sectionId} />
      ) : (
        <AdministrativeResources sheetId={id} />
      );
  else if (section === 'resources')
    content =
      id === 'new' || operation === 'edit' ? (
        <AdministrativeResourceForm id={id!} sheetId={search.sheetId} />
      ) : operation === 'renew' ? (
        <AdministrativeRenewal id={id!} />
      ) : operation === 'link' ? (
        <AdministrativeResourceLink id={id!} />
      ) : id ? (
        <AdministrativeResourceDetail id={id} initialTab={search.tab} />
      ) : (
        <AdministrativeResources
          initialKind={search.kind}
          initialProvider={search.providerAccountId}
          initialProject={search.projectId}
          initialCurrency={search.currency}
        />
      );
  else if (section === 'providers')
    content = <AdministrativeProviders id={id} operation={operation} />;
  else if (section === 'calendar') content = <AdministrativeCalendar />;
  else if (section === 'payments') content = <AdministrativePayments />;
  else if (section === 'archive' || section === 'trash')
    content = <AdministrativeResources state={section === 'archive' ? 'ARCHIVED' : 'TRASH'} />;
  else if (['members', 'roles', 'invites'].includes(section))
    content = <AdministrativeAccess section={section} id={id} operation={operation} />;
  else if (section === 'projects' || section === 'dictionaries')
    content = <AdministrativeRegistry kind={section} id={id} operation={operation} />;
  else if (section === 'audit') content = <AdministrativeAudit />;
  else if (section === 'settings') content = <AdministrativeSettings />;
  else if (section === 'telegram') content = <AdministrativeTelegram />;
  else if (section === 'import') content = <AdministrativeImport sheetId={search.sheetId} />;
  else if (section === 'jobs' && id) content = <AdministrativeJob id={id} />;
  else content = <Missing />;
  return <AdministrativeFrame>{content}</AdministrativeFrame>;
}
